import { render, staticRenderFns } from "./AuditLogs.vue?vue&type=template&id=03bc1fd8&scoped=true&"
import script from "./AuditLogs.vue?vue&type=script&lang=js&"
export * from "./AuditLogs.vue?vue&type=script&lang=js&"
import style0 from "./AuditLogs.vue?vue&type=style&index=0&id=03bc1fd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bc1fd8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VAlert,VBtn,VCard,VContainer,VIcon,VSpacer,VToolbar})
